import React from 'react'

import { MenuItem, MenuItemProps } from '@mui/material'
import { useParams } from 'react-router-dom'

import { useSearchParams } from '@edge/spark/utils'

import { useCopyDashboardCardMutation } from '@edge/spark/io-dashboards'

interface Props extends MenuItemProps {
    widgetId: string
}

export const DuplicateCardMenuItem: React.FC<Props> = ({ onClick, widgetId, className, disabled, ...rest }: Props) => {
    const { uid: userId } = useSearchParams()
    const { dashId } = useParams<{ dashId?: string }>()
    const [copyCard] = useCopyDashboardCardMutation()

    const handleClick = (event: React.MouseEvent<HTMLLIElement, MouseEvent>) => {
        onClick?.(event)
        return copyCard({
            variables: {
                userId,
                dashId,
                widgetId,
                priorDashId: dashId,
                priorUserId: userId,
            },
        })
    }

    return (
        <MenuItem {...rest} disabled={disabled} className={className} onClick={handleClick}>
            Duplicate
        </MenuItem>
    )
}
